import { authControllerSendResetPasswordLink } from "@/api/types/main";
import { SendResetPasswordLinkDTO } from "@/api/types/main/schemas";
import { authControllerSendResetPasswordLinkBody } from "@/api/types/zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "../ui/card";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";

export const SendResetPasswordLink = () => {
  const navigate = useNavigate();
  const [formError, setFormError] = useState<string | null>(null);
  const { mutate, isPending } = useMutation({
    mutationFn: async (variables: SendResetPasswordLinkDTO) =>
      await authControllerSendResetPasswordLink(variables),
    onSuccess: () => {
      form.setError("email", {
        type: "manual",
        message: "Проверьте вашу корпоративную почту.",
      });
    },
    onError: () => {
      setFormError("Произошла ошибка при отправке ссылки. Попробуйте снова.");
    },
  });

  const form = useForm<z.infer<typeof authControllerSendResetPasswordLinkBody>>({
    resolver: zodResolver(authControllerSendResetPasswordLinkBody),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data: z.infer<typeof authControllerSendResetPasswordLinkBody>) => {
    setFormError(null);
    form.clearErrors();
    mutate(data);
  };

  return (
    <div className="flex h-screen justify-center items-center">
      <Card className="w-full max-w-sm px-2">
        <CardHeader>
          <CardTitle className="text-2xl">Сброс пароля</CardTitle>
          <CardDescription>
            Введите вашу корпоративную почту и мы отправим вам ссылку для сброса пароля.
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-2">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
              {formError && <div className="text-red-500 text-center mb-4">{formError}</div>}
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input placeholder="email@champ-commerce.ru" type="email" {...field} />
                    </FormControl>
                    <FormDescription>Введите вашу корпоративную почту</FormDescription>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button className="w-full" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Загрузка...
                  </>
                ) : (
                  "Отправить"
                )}
              </Button>
            </form>
          </Form>
        </CardContent>
        <CardFooter className="flex-col gap-2">
          <Button className="w-full" variant={"outline"} onClick={() => navigate("/registration")}>
            Зарегистрироваться
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate("/login")}>
            Войти
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
